import React from 'react';
import { Route } from 'react-router-dom';
import LeaveApply from '@/pages/leave/LeaveApply';
import MyLeave from '@/pages/leave/MyLeave';
import ManageLeave from '@/pages/leave/ManageLeave';
import LeaveReport from '@/pages/leave/LeaveReport';
import LeaveHeadSetting from '@/pages/leave/LeaveHeadSetting';
import LeaveSetting from '@/pages/leave/LeaveSetting';

export const leaveRoutes = (
  <React.Fragment>
    <Route path="leave/apply" element={<LeaveApply />} />
    <Route path="leave/my-leave" element={<MyLeave />} />
    <Route path="leave/manage" element={<ManageLeave />} />
    <Route path="leave/report" element={<LeaveReport />} />
    <Route path="leave/head-setting" element={<LeaveHeadSetting />} />
    <Route path="leave/setting" element={<LeaveSetting />} />
  </React.Fragment>
);
